import { render, staticRenderFns } from "./OpenAccount.vue?vue&type=template&id=490ea27c"
import script from "./OpenAccount.vue?vue&type=script&lang=js"
export * from "./OpenAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports